import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { trackPageView } from 'utils/helpers/facebook-pixel'

import { applyHead, getPageHead } from './head'

/**
 * Keeps <head> in sync with the current route and reports page views.
 * Prerendered pages already ship the right tags; this covers client-side
 * navigation and the CRA dev server. Renders nothing.
 */
function RouteHead() {
    const { pathname } = useLocation()

    useEffect(() => {
        applyHead(getPageHead(pathname))
        trackPageView()
    }, [pathname])

    return null
}

export default RouteHead
